<template>
    <svg width="180" height="180" viewBox="0 0 180 180" fill="none" xmlns="http://www.w3.org/2000/svg">
        <!-- Background Circle -->
        <circle cx="90" cy="90" r="85" fill="#F8F9FA" opacity="0.5"/>

        <!-- Main Chat Bubble -->
        <path d="M130 50H50C43.3726 50 38 55.3726 38 62V102C38 108.627 43.3726 114 50 114H65L75 130L85 114H130C136.627 114 142 108.627 142 102V62C142 55.3726 136.627 50 130 50Z"
              fill="#E8EBED"
              stroke="#D0D7DE"
              stroke-width="2"/>

        <!-- Secondary Small Bubble (Top Right) -->
        <circle cx="125" cy="45" r="8" fill="#5625cc" opacity="0.2"/>
        <circle cx="135" cy="40" r="6" fill="#5625cc" opacity="0.3"/>

        <!-- Chat Lines (Message Placeholder) -->
        <rect x="55" y="68" width="50" height="4" rx="2" fill="#C5CCD4"/>
        <rect x="55" y="80" width="70" height="4" rx="2" fill="#C5CCD4"/>
        <rect x="55" y="92" width="45" height="4" rx="2" fill="#C5CCD4"/>

        <!-- Empty State Icon (Search/Magnifier) -->
        <g transform="translate(75, 50)">
            <circle cx="30" cy="30" r="18" fill="white" stroke="#5625cc" stroke-width="3"/>
            <path d="M43 43L52 52" stroke="#5625cc" stroke-width="3" stroke-linecap="round"/>
        </g>

        <!-- Decorative Dots -->
        <circle cx="25" cy="70" r="4" fill="#5625cc" opacity="0.15"/>
        <circle cx="155" cy="90" r="5" fill="#5625cc" opacity="0.15"/>
        <circle cx="30" cy="120" r="3" fill="#5625cc" opacity="0.2"/>
        <circle cx="150" cy="125" r="4" fill="#5625cc" opacity="0.2"/>

        <!-- Person Icon (Alternative design) -->
        <g transform="translate(20, 135)">
            <circle cx="10" cy="10" r="8" fill="#C5CCD4"/>
            <path d="M2 25C2 20 6 18 10 18C14 18 18 20 18 25" fill="#C5CCD4"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "EmptyChatList",
};
</script>

